import React from 'react'
import { cx } from 'tss-react/@emotion/css'
import { useTranslation } from 'react-i18next'
import { Controller, useFormContext } from 'react-hook-form'
import { Box, Button, TextField } from '@mui/material'
import placeholder from 'config/placeholder'
import {
  StackItemTextField,
  useStyles as textFieldStyles,
} from 'ui/shorthands/StackItemTextField'
import { StackItem } from 'ui/layout/StackItem'
import postalCodeToAddress, {
  transformToNumber,
} from 'ui/utils/PostalCodeToAddress'

const MedAddressInputForm: React.FC = () => {
  const { t } = useTranslation()
  const {
    control,
    setValue,
    getValues,
    trigger,
    setError,
    formState: { errors },
  } = useFormContext()
  const textFieldClasses = textFieldStyles().classes

  const setAddressHandler = () => {
    if (!errors.postal_code) {
      const postalCode = transformToNumber(getValues('postal_code'))
      postalCodeToAddress(postalCode)({
        success: (address) => {
          const keyValues: { [key: string]: string | undefined } = {
            postal_code: postalCode,
            prefecture: address.prefecture,
            city: address.city,
            town: address.area,
          }
          Object.keys(keyValues).forEach((key) => setValue(key, keyValues[key]))
          trigger(['postal_code', 'prefecture', 'city', 'town'])
        },
        notFound: () =>
          setError('postal_code', {
            type: 'not_found',
            message: t('該当する番号が見つかりませんでした'),
          }),
      })
    }
  }

  return (
    <>
      <StackItem label={t('郵便番号')} required>
        <Box display="flex">
          <span className={textFieldClasses.firstInput}>
            <Controller
              name={'postal_code'}
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  variant="outlined"
                  placeholder={placeholder().postal_code}
                  error={!!errors?.postal_code}
                  helperText={errors?.postal_code?.message}
                  InputProps={{
                    className: cx(!field?.value && textFieldClasses.required),
                  }}
                />
              )}
            />
          </span>
          <Button
            style={{ alignSelf: 'center' }}
            variant="contained"
            color="primary"
            onClick={setAddressHandler}
            disabled={!!errors.postal_code}
          >
            {t('住所入力')}
          </Button>
        </Box>
      </StackItem>
      <StackItemTextField
        name="prefecture"
        label={t('都道府県')}
        placeholder={placeholder().prefecture}
        errorMessage={errors?.prefecture?.message}
        control={control}
        required
      />
      <StackItemTextField
        name="city"
        label={t('市区町村')}
        placeholder={placeholder().city}
        errorMessage={errors?.city?.message}
        control={control}
        required
      />
      <StackItemTextField
        name="town"
        label={t('町域')}
        placeholder={placeholder().town}
        errorMessage={errors?.town?.message}
        control={control}
        fullWidth
        required
      />
      <StackItemTextField
        name="street"
        label={t('丁目・字通り名')}
        placeholder={placeholder().street}
        errorMessage={errors?.street?.message}
        control={control}
        fullWidth
        required
      />
      <StackItemTextField
        name="building"
        label={t('建物名')}
        placeholder={placeholder().building}
        errorMessage={errors?.building?.message}
        control={control}
        fullWidth
      />
    </>
  )
}

export default MedAddressInputForm
